import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';

export default function NotAuthorized({
  title = 'Not authorized',
  message = "You don't have permission to view this page.",
  detail = '',
  fullScreen = false,
  onSignOut
}) {
  const content = (
    <Paper variant="outlined" sx={{ width: '100%', maxWidth: 560, p: { xs: 2.5, sm: 3 }, borderRadius: 2 }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
          <Typography color="text.secondary">{message}</Typography>
        </Box>

        {detail ? <Alert severity="warning">{detail}</Alert> : null}

        {onSignOut ? (
          <Box>
            <Button variant="contained" onClick={onSignOut}>
              Sign out
            </Button>
          </Box>
        ) : null}
      </Stack>
    </Paper>
  );

  if (fullScreen) {
    return <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2.5, bgcolor: 'background.default' }}>{content}</Box>;
  }

  return (
    <Box p={3} sx={{ display: 'flex', justifyContent: 'center' }}>
      {content}
    </Box>
  );
}
